import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler, UIComponentState } from '../../../../toolkit/uicomponent';
import { MultiselectCategoryListComponentProps, MultiselectCategoryListComponentState } from './multiselectcategorylistcomponent';
import * as React from 'react';
import { BaseContext } from '../../../../../utils/basecontext';

import { MultiselectCategoryListCSSStyle } from './multiselectcategorylistcss';
import { MultiselectCategoryListViewModelImpl } from './viewmodel/multiselectcategorylistviewmodel';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { CarouselComponent, CarouselComponentProps, CarouselType } from '../../../../toolkit/carousel/carouselcomponent';
import { CategoryDto } from 'src/com/sixdee/crbtportal/core/dto/categories/categorydto';
import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';

export class MultiselectCategoryListViewImpl extends UIComponentViewImpl<UIDataModel>
{
    carouselComponent: CarouselComponent<CarouselComponentProps<CategoryDto>, UIComponentState>;

    private categoryListViewModel: MultiselectCategoryListViewModelImpl;

    constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(applicationContext, uiComponentHandler);

        this.categoryListViewModel = this.getViewModel(applicationContext);
    }

    draw(props: MultiselectCategoryListComponentProps, state: MultiselectCategoryListComponentState, cssStyle: MultiselectCategoryListCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        
        this.categoryListViewModel.setExistingSelectedCategoriesList(state.seletedCategories);
        this.categoryListViewModel.setIsEdiatble(state.isEditable);
        this.categoryListViewModel.setListDatas(state.listOfDatas);
        this.categoryListViewModel.setTitleCSSStyle(cssStyle.getTitleCSSStyle());

        return (
            <>
            {
                state.listOfDatas.length > 0 &&
                // <HorizontalListComponent arrowsPaddingType={ArrowsPaddingType.MULTISELECT_CATEGORY} arrowsSizeType={ArrowsSizeType.MULTISELECT_CATEGORY} gutterType={GutterType.MULTISELECT_CATEGORY} title={props.title} listViewModel={this.categoryListViewModel}  marginTopType={MarginTopType.MULTISELECT_CATEGORY} context={props.context}/>
          
                <div>
                     <label style={{marginTop:"40px",marginBottom:"20px",fontFamily:this.getContext().getResources().getFontFamily(),fontSize:this.getContext().getResources().getFont(Fonts.h7),color:this.getContext().getResources().getColor(Colors.color_6) }}>
                         {this.getContext().getResources().getString(Strings.preferences)}
                     </label>
                     <div style={{width:"100%",height: "200px",}}>
                        <CarouselComponent slidePerviewMobile={2} ref={(item: any) =>{this.carouselComponent = item;}} isIndicatorRequired={false} slidePerview={4} id="categories" carouselType={CarouselType.BANNER} listViewModel={this.categoryListViewModel} context={this.getUIProps().context}/>
                    </div>
               </div>
          
          }
            </>
        );
    }

    getSelectedMultiselectCategoryList(): string[]
    {
        return this.categoryListViewModel.getSelectedCategoriesList();
    }

    protected getViewModel(applicationContext: BaseContext)
    {
        return new MultiselectCategoryListViewModelImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountcomponent/categorylist/multiselectcategorylistview.tsx